import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParamsCameo } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import { PATHS, SAGA_DELAY_TIMEOUT } from '../constants/Define';
import { notification } from 'antd'
import history from './../helpers/history';

import * as SupplierAction from '../actions/supplierAction';
import * as SupplierService from './../services/supplierService';
import { supplierAutoTranslateRequest } from 'actions/autoTranslateAction';

function* getListSupplier() {
    yield takeLatest(Types.SUPPLIER_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(SupplierService.getSuppliers, params);
        yield put(SupplierAction.setSupplierList(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getSupplierProductGenerate() {
    yield takeLatest(Types.SUPPLIER_PRODUCT_GENERATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SupplierService.getSupplierProductGenerateCode, action.id);
        yield put(SupplierAction.setSupplierProductGenerate(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getListSupplierAll() {
    yield takeLatest(Types.SUPPLIER_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(SupplierService.getSupplierAll, params);
        yield put(SupplierAction.setSupplierListAll(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getSelectListSupplier() {
    yield takeLatest(Types.SUPPLIER_SELECT_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SupplierService.getSupplierSelectList);
        yield put(SupplierAction.setSupplierSelectList(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getSupplierDetail() {
    yield takeLatest(Types.SUPPLIER_GET_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SupplierService.getSupplierDetail, action.id);
        yield put(SupplierAction.setSupplierDetail(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* updateSupplier() {
    yield takeLatest(Types.SUPPLIER_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.updateSupplier, action.supplier);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.supplier.title')} "${action.supplier.supplierName}"` })
        yield put(SupplierAction.setSupplierDetail(action.supplier));
        
        if (action.supplier.targetLanguage && action.supplier.targetLanguage.length > 0) {
            yield put(supplierAutoTranslateRequest({
                sourceId: action.supplier.id,
                sourceLanguage: 'vi-VN',
                targetLanguages: action.supplier.targetLanguage,
                callbacks: action.callbacks
            }));
        } else {
            if (action.callbacks?.onSuccess) {
                yield action.callbacks.onSuccess();
            }
        }
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* createSupplier() {
    yield takeLatest(Types.SUPPLIER_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SupplierService.createSupplier, action.supplier);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.supplier.title')} "${action.supplier.supplierName}"` });
        if (action.callbacks?.onSuccess) {
            yield action.callbacks.onSuccess(result);
        }
        yield put({ type: Types.SUPPLIER_CREATE_SUCCESS });
        yield delay(SAGA_DELAY_TIMEOUT)
        history.push(PATHS.SUPPLIER.LIST.path);
        history.go();
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* deleteSupplier() {
    yield takeLatest(Types.SUPPLIER_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.deleteSupplier, action.supplier.id);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}`, description: `${i18n.t('item.supplier.title')} "${action.supplier.supplierName}"` });
        yield put(SupplierAction.getSupplierList(action.refreshParams || {}));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getSupplierDetailAddFAQs() {
    yield takeLatest(Types.SUPPLIER_GET_DETAIL_FAQs_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SupplierService.getSupplierDetailAddFAQs, action.id);
        yield put(SupplierAction.setSupplierDetailFAQ(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* createSupplierAddFAQs() {
    yield takeLatest(Types.SUPPLIER_CREATE_FAQS_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.createSupplierAddFAQs, action.supplierFAQs);
        yield delay(SAGA_DELAY_TIMEOUT)
        yield put({ type: Types.SUPPLIER_CREATE_FAQS_SUCCESS });
        yield action?.callBacks?.onSuccess();
        yield delay(SAGA_DELAY_TIMEOUT)
        yield put(SupplierAction.getSupplierDetailAddFAQs(action.supplierFAQs.supplierId));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* deleteSupplierFAQs() {
    yield takeLatest(Types.SUPPLIER_DELETE_FAQS_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.deleteSupplierFAQs, action.id);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}`, description: `${i18n.t('item.supplier.title')}` });
        yield put(SupplierAction.getSupplierDetailAddFAQs(action.supplierId));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getAllSupplierProduct() {
    yield takeLatest(Types.SUPPLIER_PRODUCT_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SupplierService.getAllSupplierProducts);
        yield put(SupplierAction.setAllSupplierProduct(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getSupplierProducts() {
    yield takeLatest(Types.SUPPLIER_PRODUCT_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.params || {});
        const result = yield call(SupplierService.getSupplierProducts, params);
        yield put(SupplierAction.setSupplierProducts(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getSupplierProductDetail() {
    yield takeLatest(Types.SUPPLIER_PRODUCT_GET_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SupplierService.getSupplierProductDetail, action.id);
        yield put(SupplierAction.setSupplierProductDetail(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getSupplierUsagePlanDetail() {
    yield takeLatest(Types.SUPPLIER_PRODUCT_USAGE_PLAN_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        // const {id, callbacks, query } = action;
        // const result = yield call(SupplierService.getSupplierUsagePlanDetail, id, query);
        const {id, callbacks } = action;
        const result = yield call(SupplierService.getSupplierUsagePlanDetail, id);
        callbacks && callbacks.onSuccess(result);

        yield put(SupplierAction.setSupplierProductDetail(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* updateSupplierProduct() {
    yield takeLatest(Types.SUPPLIER_PRODUCT_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.updateSupplierProduct, action.supplierProduct);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.supplier.supplierProduct')} "${action.supplierProduct.name}"` })
        yield put({ type: Types.SUPPLIER_PRODUCT_UPDATE_SUCCESS });
        yield put({ type: Types.SUPPLIER_PRODUCT_LIST_ALL_ACTION });
        history.push(PATHS.SUPPLIER.LIST.path, {isTab: "PRODUCT"});
        history.go();
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* createSupplierProduct() {
    yield takeLatest(Types.SUPPLIER_PRODUCT_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.createSupplierProduct, action.supplierProduct);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.supplier.supplierProduct')} "${action.supplierProduct.name}"` });
        yield put({ type: Types.SUPPLIER_PRODUCT_CREATE_SUCCESS });
        yield put({ type: Types.SUPPLIER_PRODUCT_LIST_ALL_ACTION });
        history.push(PATHS.SUPPLIER.LIST.path, {isTab: "PRODUCT"});
        history.go();
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* deleteSupplierProduct() {
    yield takeLatest(Types.SUPPLIER_PRODUCT_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.deleteSupplierProduct, action.supplierProduct.id);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.removeSuccess')}`, description: `${i18n.t('item.supplier.title')} "${action.supplierProduct.name}"` });
        yield put(SupplierAction.getSupplierProducts(action.refreshParams || {}))
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getListVinwonderSites() {
    yield takeLatest(Types.SUPPLIER_VINWONDER_SITES_ACTION, Func.sagaWrapper(function* () {
        const result = yield call(SupplierService.getVinwonderSites);
        yield put(SupplierAction.setVinwonderSites(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getListVinwonderTypes() {
    yield takeLatest(Types.SUPPLIER_VINWONDER_TYPES_ACTION, Func.sagaWrapper(function* () {
        const result = yield call(SupplierService.getVinwonderTypes);
        yield put(SupplierAction.setVinwonderTypes(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* getListVinwonderRefIds() {
    yield takeLatest(Types.SUPPLIER_VINWONDER_REFIDS_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(SupplierService.getVinwonderRefIds, action.params);
        yield put(SupplierAction.setVinwonderRefIds(result));
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

// TRANSLATE
function* createSupplierTranslate() {
    yield takeLatest(Types.SUPPLIER_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.createSupplierTranslate, action.supplier);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.supplier.translate.languageName);
        yield put({ type: Types.SUPPLIER_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.SUPPLIER_GET_DETAIL_ACTION, id: action.supplier.id });
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* updateSupplierTranslate() {
    yield takeLatest(Types.SUPPLIER_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.updateSupplierTranslate, action.supplier);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.supplier.translate.languageName);
        yield put({ type: Types.SUPPLIER_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.SUPPLIER_GET_DETAIL_ACTION, id: action.supplier.id });
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function* deleteSupplierTranslate() {
    yield takeLatest(Types.SUPPLIER_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(SupplierService.deleteSupplierTranslate, action.supplier.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.supplier.translate.languageName);
        yield put({ type: Types.SUPPLIER_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.SUPPLIER_GET_DETAIL_ACTION, id: action.supplier.id });
    }, errorHandleSupplier(Types.SUPPLIER_FAIL)))
}

function errorHandleSupplier(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'supplier');
}


export function* supplierSaga() {
    yield all([
        fork(getListSupplier),
        fork(getSupplierProductGenerate),
        fork(getListSupplierAll),
        fork(getSelectListSupplier),
        fork(getSupplierDetail),
        fork(updateSupplier),
        fork(createSupplier),
        fork(deleteSupplier),
        fork(getSupplierDetailAddFAQs),
        fork(createSupplierAddFAQs),
        fork(deleteSupplierFAQs),
        fork(getAllSupplierProduct),
        fork(getSupplierProductDetail),
        fork(getSupplierUsagePlanDetail),
        fork(updateSupplierProduct),
        fork(createSupplierProduct),
        fork(deleteSupplierProduct),
        fork(getSupplierProducts),
        fork(getListVinwonderSites),
        fork(getListVinwonderTypes),
        fork(getListVinwonderRefIds),
        fork(createSupplierTranslate),
        fork(updateSupplierTranslate),
        fork(deleteSupplierTranslate)
    ])
}
